import { camelizeKeys } from "humps";
import { HQ_SERVICE } from "app_constants";
import {
  checkStatus,
  getRequest,
  parseJSON,
  postWithoutCredentials,
} from "helpers/requests";
import type { IUser } from "types/user";

function getUser(): Promise<IUser> {
  return fetch(`${HQ_SERVICE}/user.json`, getRequest())
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys) as Promise<IUser>;
}

function confirmUser(token: string, password: string): Promise<any> {
  return fetch(
    `${HQ_SERVICE}/users/confirm`,
    postWithoutCredentials({ confirm_user: { token, password } })
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys);
}

export { getUser, confirmUser };
